import React, {useState, useEffect,useRef} from 'react';
import {
  Grid,
  Column,
  Modal,
  TextInput
} from '@carbon/react';
import { putRequestForeingEmployee} from '../../services/services';
import MessageModal from '../../components/MessageModal/MessageModal';
import SessionController from '../../components/FrontSessionController/SessionController';


const ModalRequestEmployee = ({modalRequestEmployeeCallback,closeModalRequestEmployeeCallback}) => {
  
  //for modal error or information use
  const [messageModal, setMessageModal] = useState('');
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const [requestMail, setRequestMail] = useState('');
  const [modalRequestEmployee,setModalRequestEmployee] = useState(false);
  const messageResponse = useRef([]);  
  //for showing message and making cursong round for request
  const processingRequest = useRef(false);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      // Collect all arguments passed to the debounced function
      clearTimeout(timeout); // Clear any existing timeout
      timeout = setTimeout(() => {
        func.apply(this, args); // Execute the original function with the correct context and arguments
      }, delay);
    };
  }

  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);        
    messageResponse.current = [];
  }

  const debouncedSetRequestMail = debounce(setRequestMail, 300);

  const submitRequestEmployee = async () => {    
    const request = new URLSearchParams();
    request.append('mail', requestMail);
        
    if(isRequestActive(true)){
      return;
    }
    
    await putRequestForeingEmployee(request)
    .then(response => {
      if(response.status === 200){      
        openMessageModal('Request Successful');
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(response => {            
            openMessageModal(response);
          })
      }
    });
    isRequestActive(false);
    closeModalRequestEmployee();
  }
  
  const isRequestActive = (enable) => {
    if(enable){
      if(processingRequest.current){
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;      
      return false;
    }else{
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  const closeModalRequestEmployee = () => {
    closeModalRequestEmployeeCallback()
    setModalRequestEmployee(false);
  }

  useEffect(() =>{    
    setModalRequestEmployee(modalRequestEmployeeCallback);
  },[modalRequestEmployeeCallback])

  return (
    <>      
         {modalRequestEmployeeCallback &&


        <Modal        
          className="onboarding-modal"
          modalHeading=''
          modalLabel="Invoice Approval System"
          hasscrollingcontent="false"
          onRequestClose={closeModalRequestEmployee}
          onRequestSubmit={() => submitRequestEmployee()}        
          open={modalRequestEmployee}
          primaryButtonText="Ok"
          secondaryButtonText="Cancel"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          size={'lg'}
          >                  
          <Grid >
            <Column lg={16}>
              <p>To request access for an employee, please enter their e-mail address.</p>
              <p>Keep in mind that, if the email is correct, the employee will be available after 15 minutes </p>
              <TextInput className="accounting-unit-button"     
                id={'idInputRequestEmployee'}            
                labelText={'Email (ex: watson@us.ibm.com)'}
                helperText={''}
                onChange={(e) => debouncedSetRequestMail(e.target.value)}
                style={{minWidth: '10rem',  color: '#000000 !important'}} 
                size="sm" >                                      
              </TextInput>
            </Column>
          </Grid>
        </Modal>
        }
      <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
      <SessionController messageLostSessionCallback={messageSessionLost} />
    </>
  );
};

export default ModalRequestEmployee;